import {ReactComponent as CrystalIcon} from '../../../../assets/images/icon-crystal.svg'
import AivatarButton from "../../../../components/buttons/AivatarButton";
import {useState} from "react";
import SelfCustomAvatarModal from "./SelfCustomAvatarModal";
import {useTranslation} from "react-i18next";
import {trackSelfCustomCTA} from "../../../../analytics/tracking";
import {useCurrentWorkspaceDetailQuery} from "../../../../hooks/queries";
import {getSelfCustomAvatarHistory} from "../../../../services/selfCustomAvatar";
import SelfCustomAvatarDashboardModal from "./SelfCustomAvatarDashboard";

function SelfCustomAvatarButton() {
  const [modalType, setModalType] = useState(null)
  const {data: workspace} = useCurrentWorkspaceDetailQuery()
  const {t} = useTranslation('self-custom-modal')

  const handleClick = async () => {
    trackSelfCustomCTA('project');

    try {
      const history = await getSelfCustomAvatarHistory(workspace.id)
      const hasHistory = history && history.length > 0
      setModalType(hasHistory ? 'dashboard' : 'guide')
    } catch (error) {
      console.error('[SelfCustomAvatar] 이력 조회 실패:', error)
      setModalType('guide')
    }
  }

  const closeModal = () => setModalType(null)

  return (
    <>
      <AivatarButton type="button" variant="w1" className="w-full" onClick={handleClick}>
        <span className="text-headline06 mr-[5px]">{t('셀프 커스텀 아바타 제작하기')}</span>
        <CrystalIcon/>
      </AivatarButton>

      {modalType === 'guide' && <SelfCustomAvatarModal closeModal={closeModal}/>}
      {modalType === 'dashboard' && <SelfCustomAvatarDashboardModal closeModal={closeModal}/>}
    </>
  );
}

export default SelfCustomAvatarButton
